import React, { useState } from "react";
import { Select, Tag } from "antd";
import { DownOutlined } from "@ant-design/icons";

const options = [
  { label: "디자인", value: "design" },
  { label: "개발", value: "dev" },
  { label: "기획", value: "plan" },
  { label: "마케팅", value: "marketing" },
];

const Test = () => {
  const [selectedItems, setSelectedItems] = useState([]);

  const handleChange = (values) => {
    setSelectedItems(values);
  };

  return (
    <div className="w-[300px]">
      <Select
        mode="multiple" // 1. 다중 선택 모드
        allowClear // 2. 전체 삭제 버튼
        value={selectedItems} // 3. 현재 선택된 값
        onChange={handleChange} // 4. 선택 변경 시 호출될 함수
        placeholder="역할을 선택하세요" // 5. 안내 문구
        style={{ width: "15%" }} // 6. 스타일
        suffixIcon={<DownOutlined />} // 7. 드롭다운 아이콘
        tagRender={({ label, closable, onClose }) => ( // 8. 선택된 항목(태그) 렌더링 방식
          <Tag
            color="blue"
            closable={closable}
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClose={onClose}
            style={{
              margin: "2px 3px",
              padding: "2px 8px",
              fontWeight: 500,
              borderRadius: "6px",
            }}
          >
            {label}
          </Tag>
        )}
        options={options}
        menuItemSelectedIcon={null}
      />
    </div>
  );
};

export default Test;
